module.exports = __webpack_public_path__ + "img/logoAniMemo512.e7216ae7.png";